<template>
    <va-create-layout>
        <LoanServicingEvent-form
            :title="title"
            :item="item"
        ></LoanServicingEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
